import i18next from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import I18NextHttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { IS_PRODUCTION } from '~/constants/etc';
import TranslateLocales, {
    getAllowLocales
} from '~/constants/TranslateLocales';

i18next
    .use(I18NextHttpBackend)
    .use(I18nextBrowserLanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: (code) => {
            code = code || '';
            const lang = code.replace('-', '_');
            const languages = [];

            // 중국어 번체 예외처리
            if (['zh-hk', 'zh-mo', 'zh-hant'].includes(code.toLowerCase())) {
                languages.push(TranslateLocales.ZH_TW);
            }

            // 허용한 언어가 존재하는지 확인
            if (getAllowLocales().includes(lang as TranslateLocales)) {
                languages.push(lang);
            }

            languages.push(TranslateLocales.KO);
            return languages;
        },
        debug: false,

        detection: {
            caches: []
        },

        interpolation: {
            escapeValue: false
        },

        backend: {
            loadPath: '{{lng}}',
            request: async (options, url, payload, callback) => {
                try {
                    const response = await import(`../locales/${url}`);

                    callback(null, { status: 200, data: response.default });
                } catch (error) {
                    if (!IS_PRODUCTION && error instanceof Error) {
                        console.warn(error.message);
                    }
                }
            }
        },

        react: {
            useSuspense: false
        }
    })
    .then();
